import { MaintenanceRecurrenceSubTaskModel } from 'api/models';
import { LabelColorType } from 'components/Label/labelTypes';

export const getFormattedAddress = (address: any) =>
  `${address.streetAddress}${address.unitNumber ? ` Unit ${address.unitNumber}` : ''}`;

export const getRecurrenceActivatedByUser = (recurrence: any) => {
  if (recurrence.maintenanceRecurrence.requestedBy === 'Homeowner') {
    return recurrence.homeowner;
  } else if (recurrence.maintenanceRecurrence.requestedBy === 'Resident') {
    return recurrence.resident;
  }
};

export const getRecurrenceAuthorizationNeeded = (recurrenceType: any) => {
  return (
    recurrenceType === 'Cleaning' ||
    recurrenceType === 'MaintenancePackage' ||
    recurrenceType === 'PestControl'
  );
};

export const getDateByStatus = (subtask: MaintenanceRecurrenceSubTaskModel) => {
  if (
    subtask.subTaskStatus === 'Completed' ||
    subtask.subTaskStatus === 'Scheduled'
  ) {
    return subtask.appointmentNextOn;
  }
  return subtask.requestNextOn || subtask.recommendedSchedule;
};

export const getStatus = (
  subtaskStatus?: MaintenanceRecurrenceSubTaskModel['subTaskStatus'],
): { label: string; textClassName: string; labelColor: LabelColorType } => {
  if (subtaskStatus === 'OccurringAround') {
    return {
      label: 'Upcoming',
      textClassName: 'text-navy',
      labelColor: 'blue',
    };
  }

  if (subtaskStatus === 'Completed') {
    return {
      label: 'Completed',
      textClassName: 'text-green',
      labelColor: 'green',
    };
  }

  if (subtaskStatus === 'Cancelled') {
    return { label: 'Cancelled', textClassName: 'text-red', labelColor: 'red' };
  }

  if (subtaskStatus === 'Scheduled') {
    return {
      label: 'Scheduled',
      textClassName: 'text-blue',
      labelColor: 'blue',
    };
  }

  if (subtaskStatus === 'TurnedOff') {
    return {
      label: 'Turned Off',
      textClassName: 'text-dark-gray',
      labelColor: 'gray',
    };
  }

  return { label: '', textClassName: 'text-dark-gray', labelColor: 'gray' };
};
